var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDensity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#E3C8C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33936 8.67871C8.07906 8.67871 8.67871 8.07906 8.67871 7.33936C8.67871 6.59965 8.07906 6 7.33936 6C6.59965 6 6 6.59965 6 7.33936C6 8.07906 6.59965 8.67871 7.33936 8.67871Z",
    fill: "#A84D3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7798 8.67871C11.5195 8.67871 12.1191 8.07906 12.1191 7.33936C12.1191 6.59965 11.5195 6 10.7798 6C10.0401 6 9.44043 6.59965 9.44043 7.33936C9.44043 8.07906 10.0401 8.67871 10.7798 8.67871Z",
    fill: "#A84D3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2202 8.67871C14.9599 8.67871 15.5596 8.07906 15.5596 7.33936C15.5596 6.59965 14.9599 6 14.2202 6C13.4805 6 12.8809 6.59965 12.8809 7.33936C12.8809 8.07906 13.4805 8.67871 14.2202 8.67871Z",
    fill: "#A84D3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6606 8.67871C18.4004 8.67871 19 8.07906 19 7.33936C19 6.59965 18.4004 6 17.6606 6C16.9209 6 16.3213 6.59965 16.3213 7.33936C16.3213 8.07906 16.9209 8.67871 17.6606 8.67871Z",
    fill: "#A84D3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33936 12.1191C8.07906 12.1191 8.67871 11.5195 8.67871 10.7798C8.67871 10.0401 8.07906 9.44043 7.33936 9.44043C6.59965 9.44043 6 10.0401 6 10.7798C6 11.5195 6.59965 12.1191 7.33936 12.1191Z",
    fill: "#A84D3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7798 12.1191C11.5195 12.1191 12.1191 11.5195 12.1191 10.7798C12.1191 10.0401 11.5195 9.44043 10.7798 9.44043C10.0401 9.44043 9.44043 10.0401 9.44043 10.7798C9.44043 11.5195 10.0401 12.1191 10.7798 12.1191Z",
    fill: "#A84D3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2202 12.1191C14.9599 12.1191 15.5596 11.5195 15.5596 10.7798C15.5596 10.0401 14.9599 9.44043 14.2202 9.44043C13.4805 9.44043 12.8809 10.0401 12.8809 10.7798C12.8809 11.5195 13.4805 12.1191 14.2202 12.1191Z",
    fill: "#A84D3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6606 12.1191C18.4004 12.1191 19 11.5195 19 10.7798C19 10.0401 18.4004 9.44043 17.6606 9.44043C16.9209 9.44043 16.3213 10.0401 16.3213 10.7798C16.3213 11.5195 16.9209 12.1191 17.6606 12.1191Z",
    fill: "#A84D3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33936 15.5596C8.07906 15.5596 8.67871 14.9599 8.67871 14.2202C8.67871 13.4805 8.07906 12.8809 7.33936 12.8809C6.59965 12.8809 6 13.4805 6 14.2202C6 14.9599 6.59965 15.5596 7.33936 15.5596Z",
    fill: "#A84D3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7798 15.5596C11.5195 15.5596 12.1191 14.9599 12.1191 14.2202C12.1191 13.4805 11.5195 12.8809 10.7798 12.8809C10.0401 12.8809 9.44043 13.4805 9.44043 14.2202C9.44043 14.9599 10.0401 15.5596 10.7798 15.5596Z",
    fill: "#A84D3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2202 15.5596C14.9599 15.5596 15.5596 14.9599 15.5596 14.2202C15.5596 13.4805 14.9599 12.8809 14.2202 12.8809C13.4805 12.8809 12.8809 13.4805 12.8809 14.2202C12.8809 14.9599 13.4805 15.5596 14.2202 15.5596Z",
    fill: "#A84D3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6606 15.5596C18.4004 15.5596 19 14.9599 19 14.2202C19 13.4805 18.4004 12.8809 17.6606 12.8809C16.9209 12.8809 16.3213 13.4805 16.3213 14.2202C16.3213 14.9599 16.9209 15.5596 17.6606 15.5596Z",
    fill: "#A84D3B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33936 19C8.07906 19 8.67871 18.4004 8.67871 17.6606C8.67871 16.9209 8.07906 16.3213 7.33936 16.3213C6.59965 16.3213 6 16.9209 6 17.6606C6 18.4004 6.59965 19 7.33936 19Z",
    fill: "#A84D3B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7798 19C11.5195 19 12.1191 18.4004 12.1191 17.6606C12.1191 16.9209 11.5195 16.3213 10.7798 16.3213C10.0401 16.3213 9.44043 16.9209 9.44043 17.6606C9.44043 18.4004 10.0401 19 10.7798 19Z",
    fill: "#A84D3B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2202 19C14.9599 19 15.5596 18.4004 15.5596 17.6606C15.5596 16.9209 14.9599 16.3213 14.2202 16.3213C13.4805 16.3213 12.8809 16.9209 12.8809 17.6606C12.8809 18.4004 13.4805 19 14.2202 19Z",
    fill: "#A84D3B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6606 19C18.4004 19 19 18.4004 19 17.6606C19 16.9209 18.4004 16.3213 17.6606 16.3213C16.9209 16.3213 16.3213 16.9209 16.3213 17.6606C16.3213 18.4004 16.9209 19 17.6606 19Z",
    fill: "#A84D3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensity);
export default __webpack_public_path__ + "static/media/density.1a3f461c.svg";
export { ForwardRef as ReactComponent };